import { render, staticRenderFns } from "./ApplyDocumentUpdateComponent.vue?vue&type=template&id=3607a9b7&"
import script from "./ApplyDocumentUpdateComponent.vue?vue&type=script&lang=js&"
export * from "./ApplyDocumentUpdateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports